import { Container, Space, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

const welcome = {
  confidentiality: "Garantía de confidencialidad",
  description:
    "ELSA es una herramienta digital administrada por ELSA. La información recogida es anónima y confidencial. Tu organización solo tendrá acceso a los resultados globales, mas no a tus respuestas a la encuesta.",
  duration: "Duración de la encuesta",
  durationDescription:
    "La encuesta tiene una duración variable ya que depende de las respuestas que vayas dando. Estimamos que en ningún caso su extensión será superior a los 15 minutos. ¡Muchas gracias por tu apoyo!",
};

export const SurveyWelcome2 = () => {
  const { t } = useTranslation();
  return (
    <Container fluid>
      <Text fw={700}>{welcome.confidentiality}</Text>
      <ul>
        <li>
          <Text ta="justify">{welcome.description}</Text>
        </li>
      </ul>
      <Space h="md" />
      <Text fw={700}>{welcome.duration}</Text>
      <ul>
        <li>
          <Text ta="justify">{welcome.durationDescription}</Text>
        </li>
      </ul>
    </Container>
  );
};
